import {trackAmplitudeEvent} from "@pg-mono/amplitude";
import {SiteSlug} from "@pg-mono/km-routes";

import {View} from "@/features/km_app/types/View";

import {AmplitudeButtonCategory} from "./get_amplitude_button_category_by_view";
import {trackAmplitudeButtonClick} from "./track_amplitude_button_click";

enum NavigationAmplitudeEvent {
    SELECT_SECTION = "select_section"
}

enum NavigationAmplitudeSectionName {
    MENU = "km_menu_section",
    SETTINGS = "km_settings_section",
    YOUR_ACCOUNT = "km_your_account"
}

export enum NavigationAmplitudeSource {
    DESKTOP_SIDEBAR = "desktop_sidebar",
    MOBILE_BOTTOM_NAV = "mobile_bottom_nav"
}

enum NavigationAmplitudeButtonName {
    HEADER_LOGO = "km_header_logo",
    HEADER_PORTAL = "km_header_go_to_portal"
}

enum NavigationAmplitudeButtonValue {
    DASHBOARD = "km_dashboard",
    GETHOME = "gethome",
    RYNEKPIERWOTNY = "rynekpierwotny"
}

/** DSA-A-58 KM `button_category` — `location` uses the same value. Partially overlaps the view_item maps, not identical. */
const HEADER_LOGO_SCREEN_BY_VIEW: Partial<Record<View, AmplitudeButtonCategory>> = {
    [View.APPLICATION_SENT]: AmplitudeButtonCategory.KM_SENT_OFFERS,
    [View.COMPARATOR]: AmplitudeButtonCategory.KM_OFFER_COMPARISON,
    [View.DASHBOARD]: AmplitudeButtonCategory.KM_DASHBOARD,
    [View.DISMISSED]: AmplitudeButtonCategory.KM_REJECTED,
    [View.FAVORITE]: AmplitudeButtonCategory.KM_FAVOURITE,
    [View.HOME_MATCH]: AmplitudeButtonCategory.HOMEMATCH,
    [View.PREFERENCES]: AmplitudeButtonCategory.KM_SETTINGS,
    [View.SETTINGS]: AmplitudeButtonCategory.KM_SETTINGS
};

const getHeaderLogoScreen = (viewType: View) => HEADER_LOGO_SCREEN_BY_VIEW[viewType] ?? AmplitudeButtonCategory.UNKNOWN;

interface ISelectSectionParams {
    sectionName: NavigationAmplitudeSectionName;
    selectedTab: string | null;
}

interface ISelectNamedSectionParams {
    selectedTab: string | null;
}

interface ISelectLandingNavParams {
    isUserNav: boolean;
    sectionNumber: number;
    selectedTab: string;
}

/** Navigation Amplitude tracking entry point for the whole KM app. */
export class NavigationAmplitudeTracker {
    private static trackSelectSection(params: ISelectSectionParams) {
        trackAmplitudeEvent(NavigationAmplitudeEvent.SELECT_SECTION, {
            section_name: params.sectionName,
            selected_tab: params.selectedTab
        });
    }

    static selectMenuSection(params: ISelectNamedSectionParams) {
        this.trackSelectSection({
            sectionName: NavigationAmplitudeSectionName.MENU,
            selectedTab: params.selectedTab
        });
    }

    static expandMenuSection() {
        this.selectMenuSection({selectedTab: null});
    }

    static selectSettingsSection(params: ISelectNamedSectionParams) {
        this.trackSelectSection({
            sectionName: NavigationAmplitudeSectionName.SETTINGS,
            selectedTab: params.selectedTab
        });
    }

    static expandSettingsSection() {
        this.selectSettingsSection({selectedTab: null});
    }

    static selectLandingNavItem(params: ISelectLandingNavParams) {
        trackAmplitudeEvent(NavigationAmplitudeEvent.SELECT_SECTION, {
            section_name: params.isUserNav ? NavigationAmplitudeSectionName.YOUR_ACCOUNT : NavigationAmplitudeSectionName.MENU,
            section_number: params.sectionNumber,
            selected_tab: params.selectedTab
        });
    }

    static headerLogoClick(viewType: View) {
        const screen = getHeaderLogoScreen(viewType);

        trackAmplitudeButtonClick({
            buttonCategory: screen,
            buttonName: NavigationAmplitudeButtonName.HEADER_LOGO,
            location: screen,
            value: NavigationAmplitudeButtonValue.DASHBOARD
        });
    }

    static headerPortalClick(viewType: View, siteSlug: SiteSlug) {
        const screen = getHeaderLogoScreen(viewType);
        const value = siteSlug === SiteSlug.GH ? NavigationAmplitudeButtonValue.GETHOME : NavigationAmplitudeButtonValue.RYNEKPIERWOTNY;

        trackAmplitudeButtonClick({
            buttonCategory: screen,
            buttonName: NavigationAmplitudeButtonName.HEADER_PORTAL,
            location: screen,
            value
        });
    }
}
import {trackAmplitudeEvent} from "@pg-mono/amplitude";
import {SiteSlug} from "@pg-mono/km-routes";

import {View} from "@/features/km_app/types/View";

import {AmplitudeButtonCategory} from "./get_amplitude_button_category_by_view";
import {trackAmplitudeButtonClick} from "./track_amplitude_button_click";

enum NavigationAmplitudeEvent {
    SELECT_SECTION = "select_section"
}

enum NavigationAmplitudeSectionName {
    MENU = "km_menu_section",
    SETTINGS = "km_settings_section",
    YOUR_ACCOUNT = "km_your_account"
}

export enum NavigationAmplitudeSource {
    DESKTOP_SIDEBAR = "desktop_sidebar",
    MOBILE_BOTTOM_NAV = "mobile_bottom_nav"
}

enum NavigationAmplitudeButtonName {
    HEADER_LOGO = "km_header_logo",
    HEADER_PORTAL = "km_header_go_to_portal"
}

enum NavigationAmplitudeButtonValue {
    DASHBOARD = "km_dashboard",
    GETHOME = "gethome",
    RYNEKPIERWOTNY = "rynekpierwotny"
}

/** DSA-A-58 KM `button_category` — `location` uses the same value. Partially overlaps the view_item maps, not identical. */
const HEADER_LOGO_SCREEN_BY_VIEW: Partial<Record<View, AmplitudeButtonCategory>> = {
    [View.APPLICATION_SENT]: AmplitudeButtonCategory.KM_SENT_OFFERS,
    [View.COMPARATOR]: AmplitudeButtonCategory.KM_OFFER_COMPARISON,
    [View.DASHBOARD]: AmplitudeButtonCategory.KM_DASHBOARD,
    [View.DISMISSED]: AmplitudeButtonCategory.KM_REJECTED,
    [View.FAVORITE]: AmplitudeButtonCategory.KM_FAVOURITE,
    [View.HOME_MATCH]: AmplitudeButtonCategory.HOMEMATCH,
    [View.PREFERENCES]: AmplitudeButtonCategory.KM_SETTINGS,
    [View.SETTINGS]: AmplitudeButtonCategory.KM_SETTINGS
};

const getHeaderLogoScreen = (viewType: View) => HEADER_LOGO_SCREEN_BY_VIEW[viewType] ?? AmplitudeButtonCategory.UNKNOWN;

interface ISelectSectionParams {
    sectionName: NavigationAmplitudeSectionName;
    selectedTab: string | null;
}

interface ISelectNamedSectionParams {
    selectedTab: string | null;
}

interface ISelectLandingNavParams {
    isUserNav: boolean;
    sectionNumber: number;
    selectedTab: string;
}

/** Navigation Amplitude tracking entry point for the whole KM app. */
export class NavigationAmplitudeTracker {
    private static trackSelectSection(params: ISelectSectionParams) {
        trackAmplitudeEvent(NavigationAmplitudeEvent.SELECT_SECTION, {
            section_name: params.sectionName,
            selected_tab: params.selectedTab
        });
    }

    static selectMenuSection(params: ISelectNamedSectionParams) {
        this.trackSelectSection({
            sectionName: NavigationAmplitudeSectionName.MENU,
            selectedTab: params.selectedTab
        });
    }

    static expandMenuSection() {
        this.selectMenuSection({selectedTab: null});
    }

    static selectSettingsSection(params: ISelectNamedSectionParams) {
        this.trackSelectSection({
            sectionName: NavigationAmplitudeSectionName.SETTINGS,
            selectedTab: params.selectedTab
        });
    }

    static expandSettingsSection() {
        this.selectSettingsSection({selectedTab: null});
    }

    static selectLandingNavItem(params: ISelectLandingNavParams) {
        trackAmplitudeEvent(NavigationAmplitudeEvent.SELECT_SECTION, {
            section_name: params.isUserNav ? NavigationAmplitudeSectionName.YOUR_ACCOUNT : NavigationAmplitudeSectionName.MENU,
            section_number: params.sectionNumber,
            selected_tab: params.selectedTab
        });
    }

    static headerLogoClick(viewType: View) {
        const screen = getHeaderLogoScreen(viewType);

        trackAmplitudeButtonClick({
            buttonCategory: screen,
            buttonName: NavigationAmplitudeButtonName.HEADER_LOGO,
            location: screen,
            value: NavigationAmplitudeButtonValue.DASHBOARD
        });
    }

    static headerPortalClick(viewType: View, siteSlug: SiteSlug) {
        const screen = getHeaderLogoScreen(viewType);
        const value = siteSlug === SiteSlug.GH ? NavigationAmplitudeButtonValue.GETHOME : NavigationAmplitudeButtonValue.RYNEKPIERWOTNY;

        trackAmplitudeButtonClick({
            buttonCategory: screen,
            buttonName: NavigationAmplitudeButtonName.HEADER_PORTAL,
            location: screen,
            value
        });
    }
}
